module.exports = __webpack_public_path__ + "img/stop_btn.0b67d497.png";